module.exports = __webpack_public_path__ + "static/media/upright.c0e453a2.png";